export const STATUS_COORDENADA = {
  DISPONIVEL: 'DISPONIVEL',
  INDISPONIVEL: 'INDISPONIVEL',
  TEMPORARIA: 'TEMPORARIA',
}
